

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "re-formality/src/Formality.bs.js";
import * as Arr$RecountTools from "../../util/Arr.bs.js";
import * as Modal$RecountTools from "../Modal.bs.js";
import * as Formality__ReactUpdate from "re-formality/src/Formality__ReactUpdate.bs.js";
import * as Form_Input$RecountTools from "../Form/Form_Input.bs.js";
import * as Form_Button$RecountTools from "../Form/Form_Button.bs.js";
import * as Form_Select$RecountTools from "../Form/Form_Select.bs.js";

var filterModalHeight = Curry._1(Css.merge, {
      hd: "field has-addons",
      tl: {
        hd: Curry._1(Css.style, {
              hd: Css.selector("button", {
                    hd: Css.important(Css.border(Css.px(1), "solid", Css.hex("dbdbdb"))),
                    tl: /* [] */0
                  }),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

var Styles = {
  filterModalHeight: filterModalHeight
};

var validators_value = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (input) {
      var match = input.value;
      if (match === "") {
        return {
                TAG: /* Error */1,
                _0: "Filter value is required"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: input.value
              };
      }
    })
};

var validators_name = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (input) {
      var match = input.name;
      if (match === "") {
        return {
                TAG: /* Error */1,
                _0: "Filter is required"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: input.name
              };
      }
    })
};

var validators = {
  value: validators_value,
  name: validators_name
};

function initialFieldsStatuses(_input) {
  return {
          value: /* Pristine */0,
          name: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            value: /* Pristine */0,
            name: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.value;
  var match_0 = match ? match._0 : Curry._1(validators.value.validate, input);
  var match$1 = fieldsStatuses.name;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.name.validate, input);
  var valueResult = match_0;
  var valueResult$1;
  if (valueResult.TAG === /* Ok */0) {
    var nameResult = match_0$1;
    if (nameResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                name: nameResult._0,
                value: valueResult._0
              },
              fieldsStatuses: {
                value: /* Dirty */{
                  _0: valueResult,
                  _1: /* Shown */0
                },
                name: /* Dirty */{
                  _0: nameResult,
                  _1: /* Shown */0
                }
              },
              collectionsStatuses: undefined
            };
    }
    valueResult$1 = valueResult;
  } else {
    valueResult$1 = valueResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            value: /* Dirty */{
              _0: valueResult$1,
              _1: /* Shown */0
            },
            name: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurValueField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.value, validators_value, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  value: status,
                                  name: init.name
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurNameField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.name, validators_name, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  value: init.value,
                                  name: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : error._0;
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateValueField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.value, state.submissionStatus, validators_value, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            value: status,
                                            name: init.name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateNameField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.name, state.submissionStatus, validators_name, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            value: init.value,
                                            name: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                value: /* Pristine */0,
                                name: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                value: /* Pristine */0,
                                name: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Curry._1(map, error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateValue: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateValueField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateName: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateNameField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurValue: (function (param) {
              return Curry._1(dispatch, /* BlurValueField */0);
            }),
          blurName: (function (param) {
              return Curry._1(dispatch, /* BlurNameField */1);
            }),
          valueResult: Formality.exposeFieldResult(state.fieldsStatuses.value),
          nameResult: Formality.exposeFieldResult(state.fieldsStatuses.name),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.value || match.name) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var AddFilterForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function AddFilterForm$1(Props) {
  var isActive = Props.isActive;
  var onModalClose = Props.onModalClose;
  var fields = Props.fields;
  var onSubmit = Props.onSubmit;
  var form = useForm({
        name: "",
        value: ""
      }, (function (output, cb) {
          Curry._2(onSubmit, output.name, output.value);
          return Curry._1(cb.reset, undefined);
        }));
  var modalBody = React.createElement("form", {
        onSubmit: (function ($$event) {
            $$event.preventDefault();
            return Curry._1(form.submit, undefined);
          })
      }, React.createElement(Modal$RecountTools.Header.make, {
            children: "Add a Filter"
          }), React.createElement(Modal$RecountTools.Body.make, {
            children: React.createElement("div", {
                  className: filterModalHeight
                }, React.createElement(Form_Select$RecountTools.make, {
                      label: "",
                      value: form.input.name,
                      options: Arr$RecountTools.map(fields, (function (f) {
                              return {
                                      label: f.displayName,
                                      value: f.name
                                    };
                            })),
                      disabled: form.submitting,
                      onChange: (function (e) {
                          return Curry._2(form.updateName, (function (input, value) {
                                        return {
                                                name: value,
                                                value: input.value
                                              };
                                      }), e.target.value);
                        }),
                      onBlur: (function (param) {
                          return Curry._1(form.blurName, undefined);
                        }),
                      placeholder: "Select a filter",
                      error: form.nameResult
                    }), React.createElement("div", {
                      className: "control is-expanded"
                    }, React.createElement(Form_Input$RecountTools.make, {
                          value: form.input.value,
                          label: "",
                          error: form.valueResult,
                          onChange: (function (e) {
                              return Curry._2(form.updateValue, (function (input, value) {
                                            return {
                                                    name: input.name,
                                                    value: value
                                                  };
                                          }), e.target.value);
                            }),
                          onBlur: (function (e) {
                              return Curry._1(form.blurValue, undefined);
                            }),
                          disabled: form.submitting,
                          placeholder: "Filter text"
                        })))
          }), React.createElement(Modal$RecountTools.Footer.make, {
            children: React.createElement("div", {
                  className: "field is-grouped"
                }, React.createElement(Form_Button$RecountTools.make, {
                      label: "Cancel",
                      disabled: form.submitting,
                      className: "is-gray",
                      onClick: (function (param) {
                          return Curry._1(onModalClose, undefined);
                        })
                    }), React.createElement(Form_Button$RecountTools.make, {
                      label: "Submit",
                      disabled: form.submitting,
                      kind: "submit",
                      className: "is-link"
                    }))
          }));
  return React.createElement(Modal$RecountTools.make, {
              isActive: isActive,
              children: modalBody,
              onModalClose: onModalClose
            });
}

var make = AddFilterForm$1;

export {
  Styles ,
  AddFilterForm ,
  make ,
  
}
/* filterModalHeight Not a pure module */
